import React from 'react';

class BootstrapTableSize extends React.Component {

    setPer = (event) => {
        this.props.fetch({...this.props.filter, per: event.target.value, page: 1});
    };

    render() {
        let defaultVal = '';
        let value = this.props.limitValue || defaultVal; //this.props.filter ? this.props.filter.per || defaultVal : defaultVal;
        return (
            <span className='form-inline'>
                <select className='form-control' value={value} onChange={this.setPer}>
                    <option>1</option>
                    <option>5</option>
                    <option>10</option>
                    <option>15</option>
                    <option>20</option>
                    <option>25</option>
                    <option>30</option>
                </select>
            </span>
        );
    }
}

export default BootstrapTableSize;
